import { useInstance, onMounted, findDomFromVNode } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { scrollSelect } from './styles';
export function useTranslate() {
  var instance = useInstance();
  var translate = useState(0);
  var deltaY = 0;
  onMounted(function () {
    var element = findDomFromVNode(instance.$lastInput, true);
    var rollback = ensureVisible(element);
    var _getInitMeta = getInitMeta(instance, element),
      deltaY = _getInitMeta.deltaY;
    rollback();
    translate.set(deltaY);
  });
  return {
    translate: translate
  };
}
export function getInitMeta(instance, element) {
  if (element === void 0) {
    element = findDomFromVNode(instance.$lastInput, true);
  }
  var count = instance.get('count');
  var height = element.offsetHeight;
  var itemHeight = getItemHeight();
  var deltaY = -(Math.floor(count / 2) * itemHeight - (height - itemHeight) / 2);
  return {
    deltaY: deltaY,
    itemHeight: itemHeight
  };
}
export function getItemHeight() {
  return parseInt(scrollSelect.item.height, 10);
}
function ensureVisible(element) {
  var hiddenParents = [];
  var oldStyles = [];
  var styles = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
  };
  var parent = element;
  do {
    var display = window.getComputedStyle(parent).display;
    if (display === 'none') {
      hiddenParents.push(parent);
      oldStyles.push(parent.getAttribute('style'));
      for (var style in styles) {
        parent.style[style] = styles[style];
      }
    }
    parent = parent.parentElement;
  } while (parent);
  return function () {
    hiddenParents.forEach(function (parent, index) {
      var style = oldStyles[index];
      if (style !== null) {
        parent.setAttribute('style', style);
      } else {
        parent.removeAttribute('style');
      }
    });
  };
}